import {ParamCodeExporter} from '../Param';
import {SceneCodeExporter} from '../Scene';
import {StringParam} from '../../../../../../@polygonjs/polygonjs/src/engine/params/String';
import {CoreType} from '../../../../../../@polygonjs/polygonjs/src/core/Type';

export class ParamStringCodeExporter extends ParamCodeExporter<StringParam> {
	// as_code_default_value_string() {
	// 	return `'${this._param.defaultValue()}'`;
	// }

	override add_main() {
		// if this.hasExpression()
		// 	this.as_code_prefix() + ".set_expression('#{this.expression()}')"
		// else
		let val = this._param.rawInput();
		if (CoreType.isString(val)) {
			val = SceneCodeExporter.sanitize_string(val);
		}
		// if (this._param.hasExpression()){
		// 	val = this.expression()
		// }
		// if (CoreType.isString(val)){
		// 	val = val.replace(/'/g, "\\'"); // escapes '
		// 	val = val.replace(/(\r\n|\n|\r)/gm, "\\n"); // escapes line breaks (for shader code for instance)
		// }
		const line = this.prefix() + `.set('${val}')`;
		this._lines.push(line);
	}

	override HTMLSnippet() {
		const id = this._HTMLId(this._param);
		const label = `<label for='${id}'>${id}</label>`;
		const numberInput = `<input type='text' id='${id}' name='${id}' value=${this._param.value}></input>`;
		return `${label}
${numberInput}`;
	}
	override JSSnippet() {
		const id = this._HTMLId(this._param);
		return `document.getElementById('${id}').addEventListener('input', function(event){
	scene.node('${this._param.node.path()}').p.${this._param.name()}.set(event.target.value);
})`;
	}
}
